module.exports = __webpack_public_path__ + "static/media/elo_color.28542acb.png";